export default __webpack_public_path__ + "static/licence-number-a057a883dbec24d1a71ef6b9f00e5249.png";